// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Tokelau */
const TK = /^(?:7[2-4]\d{2,5})$/;

export default TK;
